import i18n from '@lib/i18n';
import environment from '@/environment';
import { ApiUtil, displayErrorMessage } from '@everfi/reactifi';
import { TeacherGradesAndTopicsData } from '../components/TeacherSetup';
import { PreviousAccountInfo } from '../components/TeacherSSOLink';

export const skipSSOLink = (token: string) => {
  return async () => {
    await ApiUtil.requestExternalData(
      `${environment.apiBasePath.HOMEROOM}/users/skip_link_account`,
      token,
      false,
      'POST',
      {},
      false
    );
  };
};

export function submitGradesAndTopics(jwt: string, data: TeacherGradesAndTopicsData) {
  data.first_grade_age_selected_id = data.grades_ages[0];
  data.first_topic_selected_id = data.topics[0];
  return async (dispatch: Function) => {
    const url = `${environment.apiBasePath.HOMEROOM}/users/submit_sso_teacher_setup`;
    try {
      await ApiUtil.requestExternalData(
        url,
        jwt,
        false,
        'PATCH',
        {
          body: JSON.stringify({
            data: {
              type: 'new_registration',
              attributes: data,
            },
          }),
        },
        false
      );
    } catch (error) {
      dispatch(displayErrorMessage(i18n.t('Error submitting grades and topics. Please try again.')));
      throw error;
    }
  };
}

export function linkExistingProfile(jwt: string, data: PreviousAccountInfo) {
  return async (dispatch: Function) => {
    const validateUrl = `${environment.apiBasePath.HOMEROOM}/users/validate_link_account`;
    try {
      // First API call to check if account is valid
      const validateResponse = await ApiUtil.requestExternalData(
        validateUrl,
        jwt,
        false,
        'PATCH',
        {
          body: JSON.stringify({
            data: {
              attributes: data,
            },
          }),
        },
        false
      );

      if (validateResponse) {
        // If validation succeeds, link the account
        const linkUrl = `${environment.apiBasePath.HOMEROOM}/users/link_account`;
        return await ApiUtil.requestExternalData(
          linkUrl,
          jwt,
          false,
          'PATCH',
          {
            body: JSON.stringify({
              data: {
                attributes: data,
              },
            }),
          },
          false
        );
      } else {
        // Handle account link failure
        dispatch(displayErrorMessage(i18n.t('An error occurred while linking the account. Please try again later.')));
        return null;
      }
    } catch (error) {
      // Handle account validation failure
      dispatch(displayErrorMessage(i18n.t('The username or password was invalid. Please try again.')));
      throw error;
    }
  };
}
